import { type IconProps } from "../types";
import { Path, Svg } from "react-native-svg";

export const IconClose = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      color={color ?? "black"}
      {...otherProps}
    >
      <Path
        fill="currentColor"
        d="M19 6.51 17.59 5.1 12 10.69 6.41 5.1 5 6.51l5.59 5.59L5 17.69l1.41 1.41L12 13.51l5.59 5.59L19 17.69l-5.59-5.59L19 6.51Z"
      />
    </Svg>
  );
};
